"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.format = format;
// import { isFunction } from "@microsoft/fast-element/dist/esm/interfaces";
// import type { Binding, ExecutionContext } from "@microsoft/fast-element/dist/esm/observation/observable";
// import type { CaptureType, SyntheticViewTemplate } from "@microsoft/fast-element/dist/esm/templating/template";
// import { CaptureType, ExecutionContext, SyntheticViewTemplate } from "@microsoft/fast-element";
const console_1 = require("@rws-framework/console");
function format(date, format = 'yyyy-MM-dd HH:mm:ss') {
    return console_1.DateUtils.create(date).format(format);
}
